import { Flex, Icon, Stack, Text } from '@pairy/pds-react';
import cn from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useAtomValue } from 'jotai';

import useCheckUpdatingFile from '@/hooks/useCheckUpdatingFile';
import EditButton from '@/components/User/_components/pdf/FileRelatedButtons/EditButton';
import { userInfoAtom } from '@/state/user/atom';

import * as Styled from './index.styles';

interface Props {
  fileName: string;
  fileThumbnail: string;
}

const BulkEditCtaBanner = ({ fileName, fileThumbnail }: Props) => {
  const [imageLoad, setImageLoad] = useState(false);
  const router = useRouter();
  const fileId = Number(router.query?.fileId);

  const { isDisabled, handleDisabledButtonClick } = useCheckUpdatingFile();

  const userInfo = useAtomValue(userInfoAtom);

  const userPlan = userInfo?.subscriptionPlan?.name ?? 'Free';

  return (
    <EditButton
      fileId={Number(fileId)}
      isDisabled={isDisabled}
      userPlan={userPlan}
      fileName={fileName}
      fileThumbnail={fileThumbnail}
      handleDisabledButtonClick={handleDisabledButtonClick}
    >
      <Styled.Container
        className={cn({
          'background-black': !imageLoad,
        })}
        onClick={(e) => handleDisabledButtonClick(e)}
      >
        <Styled.TextWrapper padding={24}>
          <Stack gap={4} direction="column" width="100%">
            <Text variant="md-semibold" color="zinc_200">
              이미 공유한 PDF 콘텐츠를
              <br />
              링크 주소 변경 없이 업데이트를 해보세요
            </Text>
            <Text variant="xl-bold" color="white">
              PDF 수정하기
            </Text>
          </Stack>
          <Flex justifyContent="center" alignItems="center" width="fit-content">
            <Icon icon="ph:caret-right" size={24} color="white" />
          </Flex>
        </Styled.TextWrapper>

        <Image
          src="/images/banner/cta-banner-background.png"
          layout="fill"
          objectFit="fill"
          onLoadingComplete={() => setImageLoad(true)}
        />
      </Styled.Container>
    </EditButton>
  );
};

export default BulkEditCtaBanner;
